import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Dropdown, Form, Image } from "react-bootstrap";
import { GearIcon } from "../data/iconImage";

const ConfigureColumnsDisplay = ({ options, selectedOptions, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectAll, setSelectAll] = useState("custom");
  const [selectOptions, setSelectOptions] = useState(selectedOptions);

  const handleCheckboxChange = (option) => {
    const updatedOptions = selectOptions.includes(option)
      ? selectOptions.filter((val) => val !== option)
      : [...selectOptions, option];

    setSelectOptions(updatedOptions);
  };

  useEffect(() => {
    if (selectAll === "all")
      setSelectOptions(options.map(({ value }) => value));
    else setSelectOptions(selectedOptions);
  }, [selectAll]);

  useEffect(() => {
    onSelect(selectOptions);

    if (selectOptions.length === options.length) setSelectAll("all");
    else setSelectAll("custom");
  }, [selectOptions]);

  return (
    <Dropdown
      drop="down"
      align="end"
      autoClose={false}
      className="ConfigureColumns"
      show={isOpen}
      onToggle={() => setIsOpen(!isOpen)}
    >
      <Dropdown.Toggle
        variant="outline-secondary"
        className="px-3 py-2 text-dark rounded-pill"
      >
        <Image className="me-2" src={GearIcon} alt="Gear Icon" />
        กำหนดค่าการแสดงผลข้อมูล
      </Dropdown.Toggle>

      <Dropdown.Menu className="p-3">
        <div className="p-1">
          <div className="d-flex justify-content-start align-items-center">
            <Dropdown.Header className="p-0 fs-4 text-dark">
              กำหนดค่า :
            </Dropdown.Header>
            <Dropdown.Item
              className={`w-auto py-0 border-end${
                selectAll === "all" ? " active" : ""
              }`}
              onClick={() => setSelectAll("all")}
            >
              เลือกทั้งหมด
            </Dropdown.Item>
            <Dropdown.Item
              className={`w-auto py-0${
                selectAll === "custom" ? " active" : ""
              }`}
              onClick={() => setSelectAll("custom")}
            >
              กำหนดเอง
            </Dropdown.Item>
          </div>

          <Dropdown.Divider />

          <div style={{ columnCount: "2" }}>
            {options.map(({ value, label }) => (
              <Dropdown.Item
                key={value}
                className="mb-2 ps-4 d-flex align-items-center"
              >
                <Form.Check.Input
                  type="checkbox"
                  name={value}
                  checked={selectOptions.includes(value)}
                  onChange={() => handleCheckboxChange(value)}
                />
                <Form.Label htmlFor={value} className="mb-0 text-dark">
                  {label}
                </Form.Label>
              </Dropdown.Item>
            ))}
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

ConfigureColumnsDisplay.propTypes = {
  options: PropTypes.array.isRequired,
  selectedOptions: PropTypes.array,
  onSelect: PropTypes.func
};

export default ConfigureColumnsDisplay;
